import React from 'react';
import './Signature.scss';

const Signature = ({ socio, guarantor, isTwoColumn = false }) => {
  const template = (person, isGuarantor = false) => {
    return (
      <>
        <div className="row">
          <div className="col-8 pr-0">
            <p className="text-left" style={styles.m0}>
              <span className="signature-label">
                NOMBRE DEL {!isGuarantor ? 'DEUDOR' : 'AVAL'}
              </span>
              <br />
              <b>
                {`${person.nombre} ${person.apellido_paterno} ${person.apellido_materno}`}
              </b>
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-7 pr-0">
            <span className="signature-label">DIRECCIÓN</span>
            <p className="text-left" style={styles.m0}>
              <b>
                {person.domicilio_direccion} {person.domicilio_colonia}{' '}
                {person.domicilio_poblacion}, {person.domicilio_entidad} C.P.{' '}
                {person.domicilio_cp}
              </b>
            </p>
          </div>
          <div className="col-5">
            <br />
            <div className="border-dark border-top" />
            <p className="text-center" style={styles.m0}>
              Firma
            </p>
          </div>
        </div>
      </>
    );
  };
  return (
    <div className="row" style={isTwoColumn ? {} : styles.signatureContainer}>
      <div className={isTwoColumn ? 'col-6' : 'col-12'}>{template(socio)}</div>

      <div className={isTwoColumn ? 'col-6' : 'col-12'}>
        {guarantor && template(guarantor, true)}
      </div>
    </div>
  );
};

export default Signature;

const styles = {
  signatureContainer: {
    display: 'flex',
    gap: '2em',
  },
  m0: {
    margin: 0,
  },
};
